import Vue from 'vue'
import App from './matchList.vue'


new Vue({
  render: (h) => h(App),
}).$mount('#app')
